const warn = (...args) => {
  if (
    process.env.NODE_ENV !== 'production' &&
    process.env.NODE_ENV !== 'test'
  ) {
    /* eslint no-console: ["error", { allow: ["warn"] }] */
    console.warn(...args)
  }
}

export default warn



// WEBPACK FOOTER //
// ./src/utils/warn.js